module.exports = __webpack_public_path__ + "static/media/QR-code.aa6221ae.png";